const messages = {
    buttons: {
        productBrochures: "Откриване",
    },
    index: {
        title: "ИНФОРМАЦИЯ ЗА ПРОДУКТА",
        description: "Изтеглете тук най-новите брошури и листовки на нашите гуми Bridgestone и Firestone.",
        categories: {
            productBrochures: {
                title: "Продуктови брошури",
                description: "Брошури на сериите гуми Bridgestone и Firestone",
            },
            bDrive: {
              title: "Снимки на продукти",
              description: "Актуални изображения можете да изтеглите от нашия портал B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

